// API utility for making requests to the backend
// Uses environment variable in production, proxy in development

const getApiUrl = () => {
  // In production, use the REACT_APP_API_URL environment variable
  // In development, use relative paths which will be proxied
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || '';
  }
  // Development: use relative paths (proxy will handle it)
  return '';
};

export const apiUrl = getApiUrl();

// Helper to get the full API URL for an endpoint
export const getApiEndpoint = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${apiUrl}${cleanEndpoint}`;
};

export const apiRequest = async (endpoint, options = {}) => {
  const url = getApiEndpoint(endpoint);
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
  
  return fetch(url, { ...defaultOptions, ...options });
};

